import React, { useContext, useEffect, useState } from "react";
import { API_URL_MAIN } from '../../../constants/driveglobalfilterinitalstates';
import useHttp from '../../../hook/use-http';
import "./aisCustom.css";


import ChartComponent from "./ChartComponent";

import Select from "react-select";
import ChartLoader from "../Charginganalysis/ChartLoader";


export default function ChartFirst(props) {
  const [langOne, setLangOne] = useState(null);

  const { isLoading, error, sendReq: fetchData } = useHttp();

  const [firstOption, setFirstOption] = useState("")

  const [typeTitleFirst, setTypeTitleFirst] = useState("")
  const handleLanguageChangeFirst = (obj) => {
    setFirstOption(obj.code)
    setLangOne(obj);
    setTypeTitleFirst(obj.code)
    fetchData({ url: API_URL_MAIN + "arai/getData", body: { filterdata: props.filterObject } }, appyData)
  };

  const [chartData, setChartData] = useState([])
  const [orgChartData, setorgChartData] = useState([])
  const appyData = (data) => {
    setorgChartData(data)
  }

  useEffect(() => {
    var output = orgChartData.map((s, index) => (
      { "date": new Date(s._source.eventdatetime).getTime(), "value": s._source.hasOwnProperty(firstOption) ? Number(s._source[firstOption]) : null })
    );
    setChartData(output);
  }, [orgChartData])

  return (
    <div className="col-lg-12 col-md-12 col-sm-12 mt-2 mb-3">
      <div className="aisChartbox aisWd">
        <div className="v-title aisTitleChart">
          <div className="row p-1">
            <div className="col-lg-9 col-md-9 col-sm-9 col-9">
              <h6 className="mt-2 pl-2">{typeTitleFirst}</h6>
            </div>
            <div className="col-lg-3 col-md-3 col-sm-3 col-3">
              <Select
                placeholder="Select"
                value={langOne}
                options={props.langList}
                onChange={handleLanguageChangeFirst}
                getOptionLabel={x => x.name}
                getOptionValue={x => x.code}
              />
            </div>
          </div>
        </div>
        {
          (isLoading) ? <ChartLoader /> :
            <div className="d-flex align-items-end flex-column"><ChartComponent chartId={"chartdiv_first"} selected={firstOption} filterObject={props.filterObject} dynamicInterval={props.dynamicInterval} chartData={chartData} /></div>
        }
      </div>
    </div>
  );
}
